import SamsungPay from './SamsungPay'

export default SamsungPay
